<template>
  <div class="account" style="background: #fff;">
    <accountForm
      :isEdit=isEdit
      :accountName=accountName
      @accountWay="editAccount"
    ></accountForm>
  </div>
</template>
<script>
import accountForm from './accountForm'
import { getEditAccount } from '@/api/app'
export default {
  name: 'edit-account',
  created() {
    this.$store.dispatch('setPage', { title: '编辑账号', type: 'default' })
  },
  components: { accountForm },
  data() {
    return {
      isEdit: true
    }
  },
  computed: {
    // 获取 编辑的账号名称
    accountName() {
      return this.$store.state.app.editAccount
    }
  },
  methods: {
    // 编辑账号
    editAccount(data) {
      if (data.grouping === '') {
        this.$Message.info('权限组不能为空')
        return
      }
      getEditAccount({
        admin_id: data.adminId,
        admin_name: data.accountName,
        admin_password: data.passwd,
        admin_rpassword: data.passwdCheck,
        gid: data.grouping
      }).then(res => {
        if (res.code === 0) {
          localStorage.removeItem('isNull')
          this.$router.push({ name: 'accountList' })
        }
      })
    }
  }
}
</script>
<style lang="scss"></style>
